import { render, staticRenderFns } from "./RaterDataTimeCollectionTable.vue?vue&type=template&id=018ee75d&"
import script from "./RaterDataTimeCollectionTable.vue?vue&type=script&lang=js&"
export * from "./RaterDataTimeCollectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports